import type { TreeMapFilterAssetStateItem } from "./tree-map-filter-asset-state.type";
import type { AssetState } from "@/entities/asset";

import { useReferentialAssetStates } from "@/entities/referential/referential-states";

import { useTreeMap } from "../tree-map.context";
import { useTreeMapAssetsByValue } from "../tree-map.hook";

export const useTreeMapFilterAssetState = () => {
  const { states: assetStates } = useReferentialAssetStates();
  const { subFilters, toggleSubFilter, setFilterByType } = useTreeMap();

  const { getAssetsCount, getActiveAssetsCount } = useTreeMapAssetsByValue({
    getTreeNodeValue: (asset) => asset.state,
  });

  const filterItems = assetStates.map(
    ({ value, name }): TreeMapFilterAssetStateItem => ({
      value,
      name,
      count: getActiveAssetsCount(value),
      checked: subFilters.state?.includes(value),
      disabled: getAssetsCount(value) === 0,
    })
  );

  const onToggle = (state: AssetState, isChecked: boolean) => {
    toggleSubFilter({ type: "state", key: state });

    // Activate parent filter if needed
    if (!isChecked) setFilterByType("asset", true);
  };

  return {
    filterItems,
    onToggle,
  };
};
